const messages = {
    buttons: {
        productBrochures: "Otkrij",
    },
    index: {
        title: "INFORMACIJE O PROIZVODU",
        description: "Preuzmite ovdje najnovije brošure i letke o našim Bridgestone i Firestone gumama.",
        categories: {
            productBrochures: {
                title: "Brošure proizvoda",
                description: "Brošure Bridgestone i Firestone asortimana guma",
            },
            bDrive: {
              title: "Slike proizvoda",
              description: "Aktualne slike možete preuzeti na našem B-DRIVE portalu.",
            },
        
          kickback: {
            description: "Sudionicima se kešbek naknade uknjižavaju na temelju dostavljenih podataka o prihodima.",
          },}
    }
};

export default {
    messages,
};

